import {useAuthStore} from "@/store/auth";
import NavLinks from "./nav-links";
import TopNavLinks from "./top-navLinks";
export default [
  ...NavLinks,
  ...TopNavLinks,
  {
    path: "/",
    name: "login",
    component: () => import("../views/auth/login.vue"),
    meta: {
      title: "Login",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (useAuthStore().isLoggedIn) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("../views/auth/register.vue"),
    meta: {
      title: "Register",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (useAuthStore().isLoggedIn) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/forgot-password",
    name: "Forgot password",
    component: () => import("../views/auth/forgot-password.vue"),
    meta: {
      title: "Forgot Password",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (useAuthStore().isLoggedIn) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },

  {
    path: "/notfound",
    name: "notfound",
    meta: {
      title: "404",
      //
    },
    component: () => import("../views/notfound/404-cover"),
  },
  // start of import
 {
    path:  '/:pathMatch(.*)*',
    name: "not-found",
    meta: {
      title: "404",
      //
    },
    component: () => import("../views/notfound/404-cover"),
  },
  // end of import
];
